import BaseApi from "./BaseApi";

export default class ContratoService {
    static getSituacaoContrato(command) {
        return BaseApi.post(`contrato/v1/situacaocontrato`, command);
    }
}